import { GeoJSONSource } from "maplibre-gl";
import { useEffect, useMemo } from "react";
import { emptyFeatureCollection } from "../../../util/geo";
import { tagFillColor, tagHex } from "../../projects/tagColors";
import { useCaMap, useProjects } from "../../state";
import { Tag } from "../../state/types";
import { boundsForList, fitBoundsIfRelevant } from "../util";

export const ProjectControl = () => {
  const map = useCaMap();
  const { projects, selectedProjectId } = useProjects();

  const selectedProject = useMemo(
    () => projects?.find((p) => p.id === selectedProjectId),
    [projects, selectedProjectId]
  );

  const data = useMemo(() => {
    if (!projects) return emptyFeatureCollection;
    const features = projects.flatMap((project) =>
      (project.parcels || []).map((parcel: { tags?: Tag[]; [k: string]: any }) => {
        const firstTag = parcel.tags?.[0];
        const selected = project.id === selectedProjectId;
        return {
          type: "Feature",
          geometry: parcel.geometry,
          properties: {
            ...parcel,
            projectId: project.id,
            projectName: project.name,
            selected,
            tagFill: firstTag ? tagFillColor(firstTag.color, selected ? 0.55 : 0.25) : null,
            tagOutline: firstTag ? tagHex[firstTag.color] : null,
          },
        };
      })
    );
    return {
      type: "FeatureCollection",
      features,
    };
  }, [projects, selectedProjectId]);

  useEffect(() => {
    if (!map) return;
    const s = map.getSource("projects") as GeoJSONSource;
    if (s) {
      s.setData(data as any);
    }
  }, [map, data]);

  useEffect(() => {
    if (!(map && selectedProject?.parcels?.length)) return;

    const bounds = boundsForList(selectedProject.parcels);
    fitBoundsIfRelevant(map, bounds);
  }, [map, selectedProject]);

  return null;
};
